import { i18n } from "@/i18n";

export const currentFunnelStatesDataMock = [
  {
    id: "inquired",
    label: i18n.t("adoption.currentFunnelStates.funnelStates.inquired"),
    count: 20,
    color: "--color-chart-1",
  },
  {
    id: "applied",
    label: i18n.t("adoption.currentFunnelStates.funnelStates.applied"),
    count: 15,
    color: "--color-chart-2",
  },
  {
    id: "admitted",
    label: i18n.t("adoption.currentFunnelStates.funnelStates.admitted"),
    count: 10,
    color: "--color-chart-3",
  },
  {
    id: "withdrawn",
    label: i18n.t("adoption.currentFunnelStates.funnelStates.withdrawn"),
    count: 5,
    color: "--color-chart-4",
  },
  {
    id: "committed",
    label: i18n.t("adoption.currentFunnelStates.funnelStates.committed"),
    count: 5,
    color: "--color-chart-5",
  },
];
